module.exports = __webpack_public_path__ + "img/Speaker=Jonathan Javier.8ecaef16.png";